import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  FindWorkflowDocument,
  ProcurementTypePublishDocument,
  RequestTypeDetailDocument,
  WorkflowGraphFragment,
} from 'generated/resources/graphql'
import { ProcurementTypeItemFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  procurementType: ProcurementTypeItemFragment
  workflow?: WorkflowGraphFragment | null
  onClose: () => void
}
const PublishTypeModal = ({ procurementType, workflow, onClose }: Props) => {
  const { company } = useCurrentSession()

  const [publishProcurementType, { loading }] = useMutation(ProcurementTypePublishDocument, {
    extractorFn: (data) => data.procurementMutations.publishProcurementType,
    refetchQueries: [RequestTypeDetailDocument, FindWorkflowDocument],
  })

  const onPublishProcurementType = async () => {
    const result = await publishProcurementType({
      variables: {
        companyId: company.id,
        procurementTypeId: procurementType.id,
        workflowId: workflow?.id,
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
      handleClose()
    }
  }
  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      illustration="input-field"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.publish.title')}
      description={i18n.t(
        'procurement.purchase_requests.settings.types.modals.publish.description',
        {
          name: procurementType.name,
        }
      )}
      footer={
        <>
          <Button type="secondary" onClick={handleClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onPublishProcurementType} disabled={loading}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.publish.buttons.publish')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Box gap="s16"></Box>
    </Modal>
  )
}

export default PublishTypeModal
